import React, { FC } from 'react';
import classnames from 'classnames';
import { find, get } from 'lodash';
import Svg from 'svg-inline-react';
import { NavLink } from 'react-router-dom';
import { Avatar } from '@src/components/Avatar';
import { logout } from '@src/redux/actions/recruiter';
import { PROFILE_ROUTE, SETTINGS_BILLING_ROUTE } from '@src/Routes/links';
import ArrowRightSvg from '@src/svgs/arrow-right.svg';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { useSessionQuery } from '@src/graphql/generated';
import { useAppDispatch } from '@src/redux';
import { trackEvent } from '@src/metrics';
import './styles.scss';

export const SideMenu: FC = () => {
  const dispatch = useAppDispatch();

  const { data } = useSessionQuery({
    fetchPolicy: 'cache-only',
  });

  const recruiter = data?.currentRecruiter;

  const avatarProps = {
    avatarColor: recruiter?.avatarColor,
    initials: recruiter?.nameInitials,
    source: recruiter?.avatar?.fullUrl,
  };

  const NAVIGATION_LINKS = [
    { actionKey: 'OPEN_EDIT_PROFILE', isShown: true, label: 'Edit profile', to: PROFILE_ROUTE },
    { actionKey: 'OPEN_BILLING', isShown: !!recruiter?.rights.billing, label: 'Billing', to: SETTINGS_BILLING_ROUTE },
  ];

  return (
    <div className="side-menu">
      <Avatar className="side-menu__user-avatar" size="x-large" {...avatarProps} />

      <div className="side-menu__settings-popup-container">
        <div className="side-menu__settings-popup">
          <div className="side-menu__settings-popup-user">
            <Avatar className="side-menu__settings-popup-avatar" size="large" {...avatarProps} />

            <div className="side-menu__title">{recruiter?.fullName}</div>
          </div>

          <div className="side-menu__list">
            {!!recruiter?.availableCompanies && recruiter.availableCompanies.length > 1 && (
              <div className="side-menu__settings-popup-companies">
                <div className="side-menu__settings-popup-companies__inner-container">
                  <div>
                    <p>
                      {
                        recruiter.availableCompanies?.find(availableCompany => !!availableCompany.isCurrent)?.company
                          .profile.name
                      }
                    </p>
                    <p className="side-menu__settings-popup-companies__subtitle">Choose workspace</p>
                  </div>
                  <Svg className="side-menu__settings-popup-companies__icon" src={ArrowRightSvg} />
                </div>

                <div className="side-menu__companies-popup-container">
                  <div className="side-menu__companies-popup">
                    {recruiter.availableCompanies
                      .filter(({ isVisible }) => isVisible)
                      .sort((a, b) => b.isCurrent - a.isCurrent)
                      .map(({ isCurrent, company }, index) => (
                        <a
                          className={classnames('side-menu__list-item', isCurrent && 'side-menu__list-item--active')}
                          href={`/employer/switch-company/${company.id}`}
                          key={index}
                          onClick={() =>
                            trackEvent({
                              context: MetricContext.ACCOUNT,
                              interaction: MetricAction.SWITCH_WORKSPACE,
                              payload: {
                                'New Company Id': company.id,
                                'Old Company Id': get(find(recruiter.availableCompanies, 'isCurrent'), 'company.id'),
                              },
                            })
                          }
                        >
                          {company.profile.name}
                        </a>
                      ))}
                  </div>
                </div>
              </div>
            )}

            {NAVIGATION_LINKS.map(
              ({ label, to, isShown, actionKey }, i) =>
                isShown && (
                  <NavLink
                    activeClassName="side-menu__list-item--active"
                    className="side-menu__list-item"
                    exact
                    key={i}
                    onClick={() => {
                      trackEvent({
                        context: MetricContext.MAIN_NAVIGATION,
                        interaction: MetricAction[actionKey],
                      });
                    }}
                    to={to}
                  >
                    {label}
                  </NavLink>
                ),
            )}

            <div
              className="side-menu__list-item"
              onClick={() => {
                dispatch(logout());
                trackEvent({
                  context: MetricContext.ACCOUNT,
                  interaction: MetricAction.LOG_OUT,
                });
              }}
            >
              Log out
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
